import { render, staticRenderFns } from "./WorkBaseRestrictedTextField.vue?vue&type=template&id=3d8ca3c2&scoped=true"
import script from "./WorkBaseRestrictedTextField.vue?vue&type=script&lang=js"
export * from "./WorkBaseRestrictedTextField.vue?vue&type=script&lang=js"
import style0 from "./WorkBaseRestrictedTextField.vue?vue&type=style&index=0&id=3d8ca3c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8ca3c2",
  null
  
)

export default component.exports